import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { SolicitacaoAssinatura } from '@/types/assinatura';
import type { AssinaturaState } from '@/types/assinatura/assinaturaTypes';

const initialState: AssinaturaState = {
  solicitacoes: [],
  carregando: false,
  erro: null,
};

const assinaturaSlice = createSlice({
  name: 'assinatura',
  initialState,
  reducers: {
    setAssinaturaCarregando: (state, action: PayloadAction<boolean>) => {
      state.carregando = action.payload;
    },
    setAssinaturaErro: (state, action: PayloadAction<string | null>) => {
      state.erro = action.payload;
      state.carregando = false;
    },
    setAssinaturas: (state, action: PayloadAction<SolicitacaoAssinatura[]>) => {
      state.solicitacoes = action.payload;
      state.carregando = false;
      state.erro = null;
    },
    setAssinaturaEnviada: (state, action: PayloadAction<SolicitacaoAssinatura>) => {
      state.solicitacoes = [action.payload, ...state.solicitacoes];
      state.carregando = false;
      state.erro = null;
    },
    setAssinaturaCancelada: (state, action: PayloadAction<string>) => {
      state.solicitacoes = state.solicitacoes.filter((s) => s.id !== action.payload);
      state.carregando = false;
      state.erro = null;
    },
  },
});

export const { setAssinaturaErro, setAssinaturas } = assinaturaSlice.actions;

export const assinaturaReducer = assinaturaSlice.reducer;
